<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="formObserver" v-slot="{ invalid, validate }">
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                            <b-form-group label-for="Name" :label="$t('Name')">

                              <b-form-input
                                  type="text"
                                  id="Name"
                                  v-model="devicetype.name"
                                  :state="errors.length ? false : null"
                                  placeholder=""
                              />
                              <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                            </b-form-group>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Icon" v-slot="{ errors }">
                            <b-form-group label-for="Icon" :label="$t('Icon')">
                              <upload-file
                                  :fileId="devicetype.image"
                                  :isImage="true"
                                  size="2rem"
                                  @uploaded="(event) => { devicetype.image = event }"
                              />
                              <b-form-invalid-feedback>{{ $t(errors[0]) }}</b-form-invalid-feedback>
                            </b-form-group>
                          </ValidationProvider>
                        </div>
                      </div>
                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong>{{ $t('Required Fields') }}</strong>
                      </span>
                      <div class="block text-right">
                        <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                          <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t('Save') }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {BButton, BForm, BFormInput, BFormGroup, BFormInvalidFeedback} from "bootstrap-vue";
import UploadFile from "../../layouts/components/UploadFile";
import axios from 'axios';

extend("required", required);

export default {
  data() {
    return {
      devicetype: {
        name: "",
        image: null
      },
      errors: undefined,
    };
  },
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },
    save() {
      let api = this.$store.state.api + "deviceTypes";
      if (this.devicetype.id) {
        this.devicetype._method = "PUT";
        api += "/" + this.devicetype.id;
      }
      axios
          .post(api, this.devicetype)
          .then(() => {
            this.$message(
                this.$t('Success'),
                this.$t('Information saved successfully'),
                "success"
            );
            this.$router.push("/deviceTypes");
          })
          .catch((error) => {
            this.$error(error);
          });
    },
    getDeviceType(id) {
      let api = this.$store.state.api + "deviceTypes/" + id;
      axios
          .get(api)
          .then((response) => {
            this.devicetype = response.data.data[0];
          })
          .catch((error) => {
            this.$error(error);
          });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getDeviceType(id);
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    UploadFile,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
  },
};
</script>

<style scoped>
.required {
  color: red !important;
}
</style>
